import React, { Component } from "react";
import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid'
import { useNavigate, Link } from "react-router-dom";
import store from "@/redux/store";

import {FieldHolder} from "@/components/holders/FieldHolder";

import { useForm, SubmitHandler, Controller } from "react-hook-form"
import  {IUser} from "@/models/User";
import  {IAddress} from "@/models/interfaces";
import { TenantUserFields } from "./TenantUserFields"; 
import { useTranslation, withTranslation, Trans } from "react-i18next";
import { CurrentJobPanel } from "@/views/MyProfile/CurrentJobPanel";
import { useModel } from "@/models/base/useModel";
import { TagField } from "@/components/TagField/Components/TagField";
import useTagInput from "@/components/TagField/Hooks/useTag";

type props = IUser | IAddress



export function Profile({...props}) {
  const {tm, registerField} = useModel('name', props?.data);
    const register = props.register;
    const { t, i18n, ready } = useTranslation();
function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const onC = (e, p= null) => {
  
  
  return false;
}
/*
  React.useEffect(() => {
      //return;
//      console.log("watch", watch("email"));
//return;      
      if(props.data && watch("key") != props.data.key) {
          reset(props.data);
      } else if(!props.data && formState.defaultValues && formState.defaultValues["id"] && formState.defaultValues["id"] > 0) {
for (const [key, value] of Object.entries(formState.defaultValues)) {
  formState.defaultValues[key] = "";
}          
reset(formState.defaultValues, { keepDirtyValues: true }); 
          //formState.defaultValues = {};
          //reset();
      }
//    if (formState.isSubmitSuccessful) {
      //reset(undefined);
//    }
  }, [formState, reset])
*/
    let addressIndex = 0;

  return (
    <>



          <div className="px-4 py-6 sm:p-8">
            <div className="mt-10 space-y-8 pb-12 sm:space-y-0   sm:pb-0">

                  <input
                    id="key"
                    type="hidden"
                    data-dashlane-disabled-on-field="true"
                    {...register("key")}
                    key={(props.data && props.data.key) ?? null}
                    className="component block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />


            <div className="grid grid-cols-12 gap-3">
            
            <FieldHolder colspan="4" smcolspan="5" label={t('views.users.user.label.initals')} required={t('views.users.user.required.initals', '')} id="initials" error={props?.state?.error} >
                  <input
                    data-dashlane-disabled-on-field="true"
                    {...registerField('initials')}
                    className="component block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>

            <FieldHolder colspan="4" smcolspan="5" label="Geslacht" id="gender" error={props?.state?.error}>
                    
        <div className="mt-6 space-y-6 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
          <div key={"genderM"} className="flex items-center">
            <input
                id="genderM"
              name="gender"
              type="radio"
              value="M"
              {...register("gender")}
              className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
            />
            <label htmlFor={"genderM"} className="ml-3 block text-sm font-medium leading-6 text-gray-900">
              Man
            </label>
          </div>

          <div key={"genderF"} className="flex items-center">
            <input
                id="genderF"
              name="gender"
              type="radio"
              value="F"
              {...register("gender")}
              className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
            />
            <label htmlFor={"genderF"} className="ml-3 block text-sm font-medium leading-6 text-gray-900">
              Vrouw
            </label>
          </div>

          <div key={"genderU"} className="flex items-center">
            <input
                id="genderU"
              name="gender"
              type="radio"
              value="U"
              {...register("gender")}
              className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
            />
            <label htmlFor={"genderU"} className="ml-3 block text-sm font-medium leading-6 text-gray-900">
              Onbekend
            </label>
          </div>
</div>
          
  
            </FieldHolder>
            
            </div>


                <div className="grid grid-cols-12 gap-3">

            <FieldHolder colspan="12" smcolspan="5" label={t('views.users.user.label.first_name')} id="first_name" error={props?.state?.error}>                
                  <input
                    {...registerField('first_name')}
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>
              <FieldHolder colspan="12" smcolspan="2" label="Tussenvoegsel" id="preposition" error={props?.state?.error}>
                  <input
                    {...registerField('preposition')}
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
              </FieldHolder>


              <FieldHolder colspan="12" smcolspan="5" label={t('views.users.user.label.last_name')} id="last_name" error={props?.state?.error}>
                  <input
                    {...registerField('last_name')}
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
              </FieldHolder>
            </div>

            <div className="grid grid-cols-12 gap-3">
            {props?.type && props?.type > 0 && 
              <FieldHolder colspan="6" smcolspan="6" label={t('company.label.email', 'company email address')} id="companyFields.company_email" error={props?.state?.error} help={t('company.help.email', '')}>
                  <input
                    {...registerField('companyFields.company_email')}
                    type="email"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
              </FieldHolder>
            }
              <FieldHolder colspan={(props?.type > 0) ? 6 : 12} smcolspan={(props?.type > 0) ? 6 : 12} label="Prive email adres" id="email" error={props?.state?.error}>
                  <input
                    {...registerField('email')}
                    type="email"
                    autoComplete="email"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
              </FieldHolder>

              <FieldHolder colspan="6" smcolspan="6" label="Telefoon" id="phone" error={props?.state?.error}>
                  <input
                  {...registerField('phone')}
                    type="phone"
                    autoComplete="phone"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
              </FieldHolder>

              <FieldHolder colspan="12" smcolspan="6" label="Mobiel" id="mobile" error={props?.state?.error}>
                  <input
                  {...registerField('mobile')}
                    type="phone"
                    autoComplete="phone"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
              </FieldHolder>
                
                
                </div>
            {props.data && props.data.address &&
            <>
            <FieldHolder colspan="12" smcolspan="5" label="Adres" id="name" error={props?.state?.error}>                
                  <input
                    type="text"
                    {...register(`address.${addressIndex}.address` as const, {setValueAs: (e,p) => onC(e,p)} )}
                    key={(props.data && props.data.address[addressIndex].address) ?? null}
                    
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>
                
                

                
                
                <div className="grid grid-cols-12 gap-3">
              <FieldHolder colspan="12" smcolspan="3" label="Postcode" id="postal-code" error={props?.state?.error}>
                  <input
                    id="zipcode"
                    name="zipcode"
                    type="text"
                    {...register(`address.${addressIndex}.zipcode` as const)}
                    key={(props.data && props.data.address[addressIndex].zipcode) ?? null}
                    autoComplete="postal-code"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </FieldHolder>
              <FieldHolder colspan="12" smcolspan="9" label="Woonplaats" id="city" error={props?.state?.error}>
                  <input
                    id="city"
                    name="city"
                    type="text"
                    {...register(`address.${addressIndex}.residence` as const)}
                    key={(props.data && props.data.address[addressIndex].residence) ?? null}
                    autoComplete="address-level2"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
              </FieldHolder>

              </div>
              </>
                }              
            </div>
          </div>
          {props.id != "myprofile" && 
          <TenantUserFields register={register} setValue={props?.setValue} getValues={props?.getValues} registerkey={`userfields.`} control={props?.control} data={(props.data && props.data.userfields) ? props.data.userfields : null} state={props.state} user={props?.data}/>
          }
          {props.data?.jobexperience &&
          <CurrentJobPanel data={props.data}/>
          }
    </>
      );
}      